import React from "react";
import { NavLink } from "react-router-dom";
import { House, ChatCircleText, Truck, DotsThreeOutline } from "@phosphor-icons/react";

const ITEMS = [
  { to: "/home", label: "Home", icon: House, testid: "nav-home" },
  { to: "/quotations", label: "Quotations", icon: ChatCircleText, testid: "nav-quotations" },
  { to: "/orders", label: "Active orders", icon: Truck, testid: "nav-orders" },
  { to: "/more", label: "More", icon: DotsThreeOutline, testid: "nav-more" },
];

export default function BottomNav() {
  return (
    <nav
      className="fixed bottom-3 inset-x-0 z-40 px-4 pb-[env(safe-area-inset-bottom)]"
      data-testid="bottom-nav"
    >
      <div className="max-w-md mx-auto grid grid-cols-4 bg-white/85 backdrop-blur-md border border-white/60 rounded-full shadow-[0_12px_40px_-10px_rgba(0,0,0,0.45)] overflow-hidden">
        {ITEMS.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className={({ isActive }) =>
              `relative flex flex-col items-center justify-center gap-0.5 py-2.5 transition-colors duration-150 ${
                isActive
                  ? "text-[#0047AB]"
                  : "text-zinc-500 hover:text-zinc-900"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={21} weight={isActive ? "fill" : "regular"} />
                <span className={`text-[10px] font-medium tracking-tight ${isActive ? "text-[#0047AB]" : ""}`}>
                  {label}
                </span>
                {isActive && <span className="absolute bottom-1 w-1.5 h-1.5 bg-[#FF5A1F] rounded-full" />}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
